import { EventHandler } from '@n7-frontend/core';

export class ListAlertsTableEH extends EventHandler {
  public listen() {

    this.innerEvents$.subscribe(event => {
      switch(event.type){
        case 'list-alerts-table.cellClick':
          this.emitOuter('cellClick', event.payload);
          break;

        case 'list-alerts-table.cellDblClick':
            this.emitOuter('cellDblClick', event.payload);
            break;

        default: 
          break;
      }   
    });

    this.outerEvents$.subscribe(event => {
      // TODO
    });
  }
}
